/* Objects for the consumer confidence component 
Component expects shape of:
{
  title: string,
  copy: string,
  linkCopy: string || undefined,
  linkUrl: string || undefined || null,
}
*/

export const guarantee = {
  title: `Satisfaction in 4 Months or Your Money Back`,
  copy: `If you aren't 100% thrilled, return your purchase for a full refund. No questions asked`,
  linkCopy: 'Get Details',
  linkUrl: 'https://skylight.zendesk.com/hc/en-us/articles/360043182612-Refund-and-Return-Policy',
}

export const skylightPromise = {
  title: `The Skylight Promise`,
  copy: `If any device experiences a covered issue within the first 3 years, we'll replace it.`,
  linkCopy: 'Get Details',
  linkUrl: 'https://skylight.zendesk.com/hc/en-us/articles/35868177405083-The-Skylight-Promise',
}

export const support = {
  title: `Real 1-1 Support`,
  copy: `Our customer support team is available 7 days/week, 24 hours/day to help you through any questions.`,
  linkCopy: null,
  linkUrl: null,
}

// Currently used on the checkout page - not in the codebase - TO DO: Copy in figma discrepancy -> You're joining 9.3 million family members (and counting!) users around the world who have joined the Skylight family.
export const families = {
  title: `Loved by Millions`,
  copy: `You're joining 9.3 million family members (and counting!) around the world who have joined the Skylight family.`,
  linkCopy: null,
  linkUrl: null,
}
